var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "321px",
    height: "271px",
    viewBox: "0 0 321 271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C70F8119-9C69-43FE-BEC0-8BE3A95DFB4F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 128,
    cy: 142,
    r: 128
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 256,
    height: 256,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "privacy",
    transform: "translate(-992.000000, -240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cookies",
    transform: "translate(992.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    stroke: "#584DE2",
    mask: "url(#mask-2)",
    strokeWidth: 4,
    fill: "#FFFFFF",
    strokeDasharray: 10,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,188 C70.388,188 65,193.388 65,200 C65,206.612 70.388,212 77,212 C83.612,212 89,206.612 89,200 C89,193.388 83.612,188 77,188 Z",
    id: "Path-Copy-2",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,256 C121.418667,256 64,198.581333 64,128 C64,57.4186667 121.418667,0 192,0 C199.210667,0 206.517333,0.64 213.717333,1.888 C215.392,2.176 216.832,3.264 217.589333,4.78933333 C218.336,6.31466667 218.314667,8.11733333 217.525333,9.62133333 C214.741333,14.9013333 213.333333,20.64 213.333333,26.6666667 C213.333333,47.2533333 230.08,64 250.666667,64 C253.589333,64 256.64,63.5413333 260,62.6026667 C261.6,62.1653333 263.328,62.4746667 264.661333,63.488 C265.994667,64.4906667 266.773333,66.0693333 266.773333,67.7333333 C266.773333,67.904 266.709333,68.8746667 266.698667,69.056 C266.666667,84.032 278.634667,96 293.333333,96 C298.506667,96 303.434667,94.5706667 307.584,91.8506667 C309.024,90.912 310.805333,90.72 312.416,91.3386667 C314.016,91.9573333 315.221333,93.2906667 315.658667,94.944 C318.538667,105.781333 320,116.896 320,128 C320,198.581333 262.581333,256 192,256 Z",
    id: "Path",
    stroke: "#51E5A5",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#584DE2",
    cx: 285,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#584DE2",
    cx: 292,
    cy: 74,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#584DE2",
    cx: 249,
    cy: 35,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,76 C121.388,76 116,81.388 116,88 C116,94.612 121.388,100 128,100 C134.612,100 140,94.612 140,88 C140,81.388 134.612,76 128,76 Z",
    id: "Path",
    fill: "#584DE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,95 C226.388,95 221,100.388 221,107 C221,113.612 226.388,119 233,119 C239.612,119 245,113.612 245,107 C245,100.388 239.612,95 233,95 Z",
    id: "Path-Copy-7",
    fill: "#584DE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,96 C34.388,96 29,101.388 29,108 C29,114.612 34.388,120 41,120 C47.612,120 53,114.612 53,108 C53,101.388 47.612,96 41,96 Z",
    id: "Path-Copy",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.333333,181.333333 C154.721333,181.333333 149.333333,186.721333 149.333333,193.333333 C149.333333,199.945333 154.721333,205.333333 161.333333,205.333333 C167.945333,205.333333 173.333333,199.945333 173.333333,193.333333 C173.333333,186.721333 167.945333,181.333333 161.333333,181.333333 Z",
    id: "Path",
    fill: "#584DE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.333333,169 C249.721333,169 244.333333,174.388 244.333333,181 C244.333333,187.612 249.721333,193 256.333333,193 C262.945333,193 268.333333,187.612 268.333333,181 C268.333333,174.388 262.945333,169 256.333333,169 Z",
    id: "Path",
    fill: "#584DE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999834,135.341333 C101.487706,135.341333 100.975578,135.14526 100.58348,134.757114 L96.5824796,130.755614 C95.8022846,129.975321 95.8022846,128.706845 96.5824796,127.926553 C97.3626747,127.14626 98.6309917,127.14626 99.4111868,127.926553 L103.412187,131.928053 C104.192382,132.708346 104.192382,133.976822 103.412187,134.757114 C103.02409,135.14526 102.511962,135.341333 101.999834,135.341333 Z",
    id: "Path",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.999834,156.674667 C197.487706,156.674667 196.975578,156.478593 196.58348,156.090448 L192.58248,152.088947 C191.802285,151.308654 191.802285,150.040179 192.58248,149.259886 C193.362675,148.479594 194.630992,148.479594 195.411187,149.259886 L199.412187,153.261387 C200.192382,154.041679 200.192382,155.310155 199.412187,156.090448 C199.02409,156.478593 198.511962,156.674667 197.999834,156.674667 L197.999834,156.674667 Z",
    id: "Path",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.999834,53.6746667 C178.487706,53.6746667 177.975578,53.4785931 177.58348,53.0904476 L173.58248,49.088947 C172.802285,48.3086544 172.802285,47.0401787 173.58248,46.2598861 C174.362675,45.4795935 175.630992,45.4795935 176.411187,46.2598861 L180.412187,50.2613867 C181.192382,51.0416793 181.192382,52.310155 180.412187,53.0904476 C180.02409,53.4785931 179.511962,53.6746667 178.999834,53.6746667 L178.999834,53.6746667 Z",
    id: "Path-Copy-4",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.999834,250.674667 C85.4877059,250.674667 84.9755779,250.478593 84.5834799,250.090448 L80.5824796,246.088947 C79.8022846,245.308654 79.8022846,244.040179 80.5824796,243.259886 C81.3626747,242.479594 82.6309917,242.479594 83.4111868,243.259886 L87.412187,247.261387 C88.1923821,248.041679 88.1923821,249.310155 87.412187,250.090448 C87.02409,250.478593 86.511962,250.674667 85.999834,250.674667 L85.999834,250.674667 Z",
    id: "Path-Copy-6",
    fill: "#584DE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.332167,199.341333 C214.820039,199.341333 214.307911,199.14526 213.915813,198.757114 C213.135618,197.976822 213.135618,196.708346 213.915813,195.928053 L217.916813,191.926553 C218.697008,191.14626 219.965325,191.14626 220.74552,191.926553 C221.525715,192.706845 221.525715,193.975321 220.74552,194.755614 L216.74452,198.757114 C216.356423,199.14526 215.844295,199.341333 215.332167,199.341333 L215.332167,199.341333 Z",
    id: "Path",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.998834,103.341333 C193.486706,103.341333 192.974578,103.14526 192.58248,102.757114 C191.802285,101.976822 191.802285,100.708346 192.58248,99.9280534 L196.58348,95.9265528 C197.363675,95.1462602 198.631992,95.1462602 199.412187,95.9265528 C200.192382,96.7068454 200.192382,97.9753211 199.412187,98.7556137 L195.411187,102.757114 C195.02309,103.14526 194.510962,103.341333 193.998834,103.341333 L193.998834,103.341333 Z",
    id: "Path",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.332167,135.341333 C150.820039,135.341333 150.307911,135.14526 149.915813,134.757114 C149.135618,133.976822 149.135618,132.708346 149.915813,131.928053 L153.916813,127.926553 C154.697008,127.14626 155.965325,127.14626 156.74552,127.926553 C157.525715,128.706845 157.525715,129.975321 156.74552,130.755614 L152.74452,134.757114 C152.356423,135.14526 151.844295,135.341333 151.332167,135.341333 L151.332167,135.341333 Z",
    id: "Path",
    fill: "#51E5A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.332167,174.341333 C32.820039,174.341333 32.307911,174.14526 31.915813,173.757114 C31.1356179,172.976822 31.1356179,171.708346 31.915813,170.928053 L35.9168132,166.926553 C36.6970083,166.14626 37.9653253,166.14626 38.7455204,166.926553 C39.5257154,167.706845 39.5257154,168.975321 38.7455204,169.755614 L34.7445201,173.757114 C34.3564231,174.14526 33.8442951,174.341333 33.332167,174.341333 L33.332167,174.341333 Z",
    id: "Path-Copy-5",
    fill: "#584DE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.332167,69.3413333 C56.820039,69.3413333 56.307911,69.1452598 55.915813,68.7571143 C55.1356179,67.9768216 55.1356179,66.708346 55.915813,65.9280534 L59.9168132,61.9265528 C60.6970083,61.1462602 61.9653253,61.1462602 62.7455204,61.9265528 C63.5257154,62.7068454 63.5257154,63.9753211 62.7455204,64.7556137 L58.7445201,68.7571143 C58.3564231,69.1452598 57.8442951,69.3413333 57.332167,69.3413333 L57.332167,69.3413333 Z",
    id: "Path-Copy-3",
    fill: "#584DE2",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookies);
export default __webpack_public_path__ + "static/media/cookies.5b3cc024.svg";
export { ForwardRef as ReactComponent };